export const INPROGRESS = 'INPROGRESS'
export const SUCCESS = 'SUCCESS'
export const ERROR = 'ERROR'

export const get12HrsFormatValue = (time) => {
  return `${time.split(':')[0] - 12}:${time.split(':')[1]}`
}
